import { ReleaseResourceAccessStatus } from "@/routes/simulator/types";

// Enum matching backend SnippetStatus
export enum SnippetStatus {
  DRAFT = 'DRAFT',
  VERIFIED = 'VERIFIED',
  OUTDATED = 'OUTDATED',
}

export interface ReleaseAccessSnippet {
  releaseId: string;
  status: ReleaseResourceAccessStatus;
}

// Version information for a snippet
export interface SnippetVersion {
  id: string;
  status: SnippetStatus;
  versionName: string | null;
  approvalNote: string | null;
  title: string;
  content: string;
  verifiedAt: Date | null;
  updatedAt: Date;
}

// List item returned from GET /snippets
export interface Snippet {
  id: string;
  title: string;
  path: string;
  isInternal: boolean;
  isVerifiedVersionAvailable: boolean;
  isCurrentVersionVerified: boolean;
}

// Full snippet with versions, returned from GET /snippets/:id
export interface SnippetDetail {
  id: string;
  path: string;
  isInternal: boolean;
  isVerifiedVersionAvailable: boolean;
  isCurrentVersionVerified: boolean;
  tags: string[];
  updatedAt: Date;
  deletedAt: Date | null;
  versions: SnippetVersion[];
  accessLabels?: string[];
  releaseAccessSnippets: ReleaseAccessSnippet[];
}

// Tree node for hierarchical display
export interface SnippetTreeNode {
  id: string;
  name: string;
  type: 'file' | 'folder';
  children?: SnippetTreeNode[];
  snippetCount?: number;
  snippetId?: string; // Renamed from articleId
  path?: string;
  isVerifiedVersionAvailable?: boolean;
  isInternal?: boolean;
}

// ============================================================================
// Request/Response DTOs for API calls
// ============================================================================

// Create snippet request
export interface CreateSnippetDto {
  path: string;
  title?: string;
  isInternal?: boolean;
}

// Create snippet response
export interface CreateSnippetResponse {
  id: string;
}

// Delete snippets request (batch delete)
export interface DeleteSnippetDto {
  snippetIds: string[];
}

// Update snippet request
export interface UpdateSnippetDto {
  path: string;
}

// Save/update snippet version draft request
export interface SaveSnippetVersionDto {
  title: string;
  content: string;
}

// Verify snippet version request
export interface VerifySnippetVersionDto {
  versionName: string;
  approvalNote?: string;
  releaseAccessSnippets?: ReleaseAccessSnippet[];
}

// Presign attachment upload request
export interface PresignAttachmentDto {
  fileType: string;
  fileSize: number;
}

// Presign attachment upload response
export interface PresignAttachmentResponse {
  uploadUrl: string;
  publicUrl: string;
  key: string;
}
